import { PROFILE__SET_PROFILE } from './types';

export const setProfile = profile => ( { type: PROFILE__SET_PROFILE, profile } );
